import { useEffect } from "react"
import { CommandButton, Loading, PrintTransactionModal } from "components"
import { FormSection } from "./FormSection"
import { FormProvider, useForm } from "react-hook-form"
import moment from "moment"
import { type FormType, useReceivedDetail } from "../utils"
import { useToggle } from "utils"

export default function Detail(params: { received_reject_id: number }): JSX.Element {
  const { isActive, toggle } = useToggle(false)
  const { data, isLoading, rejectData } = useReceivedDetail(params.received_reject_id)

  const defaultValues: FormType = {
    memo: "",
    referensi: "",
    transaction_date: moment().format("YYYY-MM-DD"),
    received_reject_detail: []
  }
  const methods = useForm<FormType>({ defaultValues, disabled: true })

  useEffect(() => {
    if (data && rejectData) {
      methods.reset({
        referensi: "",
        memo: data.memo,
        transaction_date: data.transaction_date,
        received_reject_detail: data.detail.map(item => {
          // Vars
          const detail = rejectData.detailreject.find(detail => detail.product_id === item.product_id)

          return {
            ...item,
            qty_back_delivered: detail?.qty_back_delivered ?? 0,
            unit_measure: detail?.unit_measure ?? "-",
          }
        })
      })
    }

    // eslint-disable-next-line
  }, [data, rejectData])

  if (isLoading || !data) {
    return (
      <Loading
        errorText="No data available"
        loading={isLoading}
      />
    )
  }

  return (
    <div className="container my-5 flex flex-col gap-3">
      <FormProvider {...methods}>
        <FormSection
          data={{
            address: data.address,
            approve_by: data.approve_by,
            approve_status: data.approve_status,
            detailreject: rejectData?.detailreject ?? [],
            location_id: data.location_id,
            reject_id: data.reject_id,
            reject_status: rejectData?.reject_status ?? 0,
            trx_code: data.trx_code,
            transaction_date: rejectData?.transaction_date ?? "",
            vendor_id: data.vendor_id
          }}
          is_detail={true}
        />

        <CommandButton actiontype="print" onClick={toggle} />
        
        {isActive ? (
          <PrintTransactionModal isLandscape toggle={toggle}>
            <FormSection
              isPrint
              data={{
                address: data.address,
                approve_by: data.approve_by,
                approve_status: data.approve_status,
                detailreject: rejectData?.detailreject ?? [],
                location_id: data.location_id,
                reject_id: data.reject_id,
                reject_status: rejectData?.reject_status ?? 0,
                trx_code: data.trx_code,
                transaction_date: rejectData?.transaction_date ?? "",
                vendor_id: data.vendor_id
              }}
              is_detail={true}
            />
          </PrintTransactionModal>
        ) : null} 
      </FormProvider>
    </div>
  )
}